<template>
  <v-hover v-slot:default="{ hover }" :disabled="disabled">
    <div>
      <v-card
        flat
        height="175"
        width="175"
        :class="[
          'rounded-10',
          'blue-border',
          { 'btn-primary': hover, 'disabled-button': disabled }
        ]"
        @click="$emit('chooseOrder', 'IMMEDIATE-CASE')"
      >
        <v-card-text
          class="px-1 text-center text-subtitle-1 pb-0"
          :style="{
            color: hover ? 'white' : '#147BD1'
          }"
        >
          <strong> IMMEDIATE NEXUS 360° </strong>
        </v-card-text>
        <v-container fluid class="pt-0">
          <v-img
            contain
            :src="require('@/assets/immediate-nexus-360.png')"
            position="center center"
          />
        </v-container>
      </v-card>
    </div>
  </v-hover>
</template>

<script>
export default {
  name: "ImmediateNexus360Button",

  props: ["disabled"]
}
</script>

<style scoped>
.disabled-button {
  cursor: not-allowed;
  pointer-events: none;
  filter: grayscale(10%) brightness(80%);
  opacity: 0.5;
}
</style>
